import React, { Component } from "react";
import { connect } from "react-redux";
import ActionGame from "../../../assets/images/topic-action@3x.png";
import i18n from "../../../i18n";

class DashboardFreeToPlayGamesCardComponent extends Component {
  addDefaultSrc(ev) {
    ev.target.src = ActionGame;
  }

  render() {
    const lang = i18n.language;
    return (
      <a
        href={
          this.props.isLoggedIn
            ? "/" +
              lang +
              "/category/" +
              this.props.id +
              "/" +
              this.props.description
            : ""
        }
      >
        <div className="card free-to-play-game">
          <img
            className="card-img"
            src={this.props.imageUrl ? this.props.imageUrl : ActionGame}
            alt={this.props.description}
            onError={this.addDefaultSrc}
          />
          <h4 className="mt-3 bold">{this.props.description}</h4>
        </div>
      </a>
    );
  }
}

const defaultProps = {
  id: 1,
  imageUrl: ActionGame,
  description: "Action"
};

const mapStateToProps = state => {
  return {
    isLoggedIn: state.login.isLoggedIn
  };
};

DashboardFreeToPlayGamesCardComponent.defaultProps = defaultProps;

export default connect(
  mapStateToProps,
  defaultProps
)(DashboardFreeToPlayGamesCardComponent);
